import { render } from "./News2025ss.vue?vue&type=template&id=2631df1e&scoped=true"
import script from "./News2025ss.vue?vue&type=script&lang=js"
export * from "./News2025ss.vue?vue&type=script&lang=js"

import "./News2025ss.vue?vue&type=style&index=0&id=2631df1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2631df1e"]])

export default __exports__